import store from '../store/store.js'

export default async (to, from, next) =>  {
  await store.dispatch('autoLogin')
  console.log(to.name !== 'page-2fa')
  if (to.name !== 'page-2fa' && ! (store.getters.currentUser && store.getters.currentUser.is_google_2fa_enable)) {
    next({
      path: '/pages/customer-2fa',
      replace: true
    })
  }
  if (to.name !== 'page-login') {
    if (store.getters.isLogedIn) {
      next()
    } else {
      next({
        path: '/pages/login',
        replace: true
      })
    }
  } else if (store.getters.isLogedIn) {
    next({
      path: '/',
      replace: true
    })
  }
  next()
}
